﻿const jQuery = window.jQuery;

export default class Account {
    constructor() {
        this.account = jQuery('#account');
    }

    deletePaymentMethod() {
        var self = this;
        var removeModal = jQuery('#removePaymentMethodModal');
        var confirmBtn = removeModal.find('[data-confirm-remove-payment]');

        // Opening the confirm dialog just stashes which card's delete button was clicked; the
        // actual AJAX delete only fires once the user clicks "Remove" below.
        removeModal.on('dialog:open', function (event) {
            var trigger = event.originalEvent && event.originalEvent.detail ? event.originalEvent.detail.trigger : null;
            var token = trigger ? jQuery(trigger).data('token') : null;
            confirmBtn.data('token', token);
        });

        confirmBtn.click(function () {
            var token = jQuery(this).data('token');
            if (!token) {
                return;
            }

            window.jQuery.LoadingOverlay('show');
            jQuery
                .ajax('/wp/wp-admin/admin-ajax.php?action=amenities_delete_payment_method', {
                    method: 'POST',
                    data: {
                        token: token,
                        security: window.twf && window.twf.account_nonce,
                    },
                    success: function (response) {
                        if (response.status !== 'success') {
                            self.showErrorMessage();
                            return;
                        }

                        var $method = jQuery('.wc-account-pm__method[data-token="' + token + '"]');
                        var wasDefault = $method.hasClass('wc-account-pm__method--default');

                        $method.remove();

                        var $remaining = jQuery('.wc-account-pm__method');

                        if ($remaining.length === 0) {
                            jQuery('.wc-account-pm__list-wrap').prop('hidden', true);
                            jQuery('.wc-account-pm__empty').prop('hidden', false);
                        } else if (wasDefault) {
                            $remaining.first().addClass('wc-account-pm__method--default');
                        }

                        removeModal.find('[data-dialog-dismiss]').first().click();
                    },
                })
                .fail(function (jqXHR) {
                    var message = jqXHR.responseJSON && jqXHR.responseJSON.message;

                    if (message) {
                        notify.error(message);
                    } else {
                        self.showErrorMessage();
                    }
                })
                .always(function () {
                    window.jQuery.LoadingOverlay('hide');
                });
        });
    }

    initPaymentValidation(id, event) {
        var formField = jQuery(id).closest('.form-field');
        var errorEl = formField.find('.form-field__error');

        if (event.error) {
            errorEl.text(event.error.message);
            formField.addClass('form-field--error');
        } else if (event.empty) {
            errorEl.text('Required');
            formField.addClass('form-field--error');
        } else {
            errorEl.text('');
            formField.removeClass('form-field--error');
        }
    }

    addPaymentMethod() {
        var self = this;
        var account = jQuery('#account');
        if (account.length) {
            var paymentModal = jQuery('#paymentModal');
            var form = jQuery('#addPaymentMethodForm');
            if (typeof Stripe === 'undefined') {
                console.error('Stripe.js failed to load.');
                return;
            }
            var publishableKey = (window.twf && window.twf.publishable_key) || account.data('public-key');
            var stripe = Stripe(publishableKey);
            var elements = stripe.elements();
            // Colors match the reskinned (light) #paymentModal — this used to be light/white text
            // for the modal's previous dark background; must stay in sync with that background.
            var style = {
                base: {
                    color: '#1f2937',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#6b7280',
                    },
                    ':focus': {
                        color: '#1f2937',
                    },
                },
                invalid: {
                    color: '#e5424d',
                    ':focus': {
                        color: '#e5424d',
                    },
                },
            };
            var cardNumberElement = elements.create('cardNumber', {
                iconStyle: 'solid',
                style: style,
                placeholder: 'xxxx xxxx xxxx xxxx',
            });
            var cardExpiryElement = elements.create('cardExpiry', {
                style: style,
                placeholder: 'XX/XX',
            });
            var cardCvcElement = elements.create('cardCvc', {
                style: style,
                placeholder: 'CVV/CVC',
            });
            cardNumberElement.mount('#cardNumber1');
            cardNumberElement.addEventListener('change', function (event) {
                self.initPaymentValidation('#cardNumber1', event);
            });

            cardExpiryElement.mount('#expiryDate1');
            cardExpiryElement.addEventListener('change', function (event) {
                self.initPaymentValidation('#expiryDate1', event);
            });

            cardCvcElement.mount('#cvv1');
            cardCvcElement.addEventListener('change', function (event) {
                self.initPaymentValidation('#cvv1', event);
            });

            paymentModal.on('dialog:open', function () {
                form.trigger('reset');
                cardNumberElement.clear();
                cardExpiryElement.clear();
                cardCvcElement.clear();
            });

            form.submit(function (e) {
                e.preventDefault();

                var ajaxUrl = (window.twf && window.twf.ajax_url) || '/wp/wp-admin/admin-ajax.php';
                var $submitBtn = form.find('button[type="submit"]');

                function resetSubmitState() {
                    window.jQuery.LoadingOverlay('hide');
                    $submitBtn.prop('disabled', false);
                }

                $submitBtn.prop('disabled', true);
                window.jQuery.LoadingOverlay('show');

                // Step 1: Create SetupIntent on server
                jQuery
                    .ajax(ajaxUrl, {
                        method: 'POST',
                        data: {
                            action: 'amenities_create_setup_intent',
                            security: window.twf && window.twf.account_nonce,
                        },
                        success: function (response) {
                            if (response.status !== 'success') {
                                resetSubmitState();
                                notify.error(response.message || 'Server error.');
                                return;
                            }

                            var clientSecret = response.data.client_secret;

                            // Step 2: Confirm card setup with Stripe
                            stripe
                                .confirmCardSetup(clientSecret, {
                                    payment_method: {
                                        card: cardNumberElement,
                                        billing_details: {
                                            name: jQuery('#cardHolderName1').val(),
                                        },
                                    },
                                })
                                .then(function (result) {
                                    if (result.error) {
                                        resetSubmitState();
                                        notify.error(result.error.message);
                                        return;
                                    }

                                    // Step 3: Save PaymentMethod on server
                                    jQuery
                                        .ajax(ajaxUrl, {
                                            method: 'POST',
                                            data: {
                                                action: 'amenities_add_payment_method',
                                                security: window.twf && window.twf.account_nonce,
                                                payment_method_id: result.setupIntent.payment_method,
                                            },
                                            success: function (response) {
                                                if (response.status === 'success') {
                                                    window.location.href =
                                                        '/account/?card_added=1&tab=payment-plan-content';
                                                } else {
                                                    resetSubmitState();
                                                    notify.error(response.message || 'Could not save card.');
                                                }
                                            },
                                        })
                                        .fail(function () {
                                            resetSubmitState();
                                            self.showErrorMessage();
                                        });
                                })
                                .catch(function () {
                                    // confirmCardSetup normally resolves even for declined cards (result.error
                                    // above) — this only fires for a genuine rejection (e.g. network failure
                                    // calling Stripe), which would otherwise strand the UI mid-spinner.
                                    resetSubmitState();
                                    self.showErrorMessage();
                                });
                        },
                    })
                    .fail(function () {
                        resetSubmitState();
                        self.showErrorMessage();
                    });
            });
        }
    }

    setDefaultPaymentMethod() {
        var self = this;

        jQuery('.wc-account-pm__method-set-default').click(function () {
            var $button = jQuery(this);
            var paymentMethodId = $button.data('payment-method-id');
            var $newDefault = $button.closest('.wc-account-pm__method');
            var $prevDefault = jQuery('.wc-account-pm__method--default');

            window.jQuery.LoadingOverlay('show');
            jQuery
                .ajax('/wp/wp-admin/admin-ajax.php?action=amenities_set_default_payment_method', {
                    method: 'POST',
                    data: {
                        payment_method_id: paymentMethodId,
                        security: window.twf && window.twf.account_nonce,
                    },
                    success: function (response) {
                        if (response.status === 'success') {
                            $prevDefault.removeClass('wc-account-pm__method--default');
                            $newDefault.addClass('wc-account-pm__method--default');
                            self.showSuccessMessage('Default payment method updated.');
                        } else {
                            self.showErrorMessage();
                        }
                    },
                })
                .fail(function () {
                    self.showErrorMessage();
                })
                .always(function () {
                    window.jQuery.LoadingOverlay('hide');
                });
        });
    }

    pausePlan() {
        var self = this;

        jQuery('#changePlanStatus').on('show.bs.modal', function (event) {
            var button = jQuery(event.relatedTarget);
            var planId = button.data('plan-id');
            var oldPlanStatus = button.data('plan-status');

            var modal = jQuery(this);
            var changePlanStatusBtn = modal.find('.change-plan-status');

            changePlanStatusBtn.text(button.text());

            if (oldPlanStatus === 'active') {
                modal.find('.active-plan-content').addClass('d-none');
                modal.find('.pause-plan-content').removeClass('d-none');
            } else {
                modal.find('.active-plan-content').removeClass('d-none');
                modal.find('.pause-plan-content').addClass('d-none');
            }

            modal.find('.change-plan-status').click(function () {
                jQuery
                    .ajax('/wp/wp-admin/admin-ajax.php?action=amenities_pause_plan', {
                        method: 'POST',
                        data: {
                            plan_id: planId,
                            old_pan_status: oldPlanStatus,
                            security: window.twf && window.twf.account_nonce,
                        },
                        success: function (response) {
                            if (response.status === 'success') {
                                if (oldPlanStatus === 'active') {
                                    button.html('<i class="fas fa-play"></i>' + button.data('activate-message'));
                                    button.data('plan-status', 'on-hold');
                                } else {
                                    button.html('<i class="fas fa-pause"></i>' + button.data('pause-message'));
                                    button.data('plan-status', 'active');
                                }
                            }
                        },
                    })
                    .always(function () {})
                    .fail(function () {
                        modal.modal('hide');
                        self.showErrorMessage();
                    });
            });
        });
    }

    downloadInvoice() {
        var self = this;

        jQuery('[data-download-invoice]').click(function (e) {
            e.preventDefault();

            var $link = jQuery(this);
            var url = $link.attr('href');
            var orderId = $link.data('order-id');

            window.jQuery.LoadingOverlay('show');
            jQuery
                .ajax(url, {
                    method: 'GET',
                    xhrFields: {
                        responseType: 'blob',
                    },
                })
                .done(function (blob) {
                    if (!(blob instanceof Blob) || blob.type !== 'application/pdf') {
                        self.showErrorMessage();
                        return;
                    }

                    var blobUrl = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement('a');
                    tempLink.href = blobUrl;
                    tempLink.download = 'invoice-' + orderId + '.pdf';
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobUrl);
                })
                .fail(function () {
                    self.showErrorMessage();
                })
                .always(function () {
                    window.jQuery.LoadingOverlay('hide');
                });
        });
    }

    removeBirthCertificate() {
        var self = this;

        jQuery('#removeDoc18Submit').click(function (e) {
            e.preventDefault();

            window.jQuery.LoadingOverlay('show');
            jQuery
                .ajax('/wp/wp-admin/admin-ajax.php?action=amenities_remove_birth_certificate', {
                    method: 'POST',
                    data: {
                        security: window.twf && window.twf.account_nonce,
                    },
                    success: function (response) {
                        if (response.status !== 'success') {
                            self.showErrorMessage();
                            return;
                        }

                        jQuery('#removeDoc18').fadeOut(300, function () {
                            jQuery(this).remove();
                        });
                    },
                })
                .fail(function () {
                    self.showErrorMessage();
                })
                .always(function () {
                    window.jQuery.LoadingOverlay('hide');
                });
        });
    }

    showErrorMessage() {
        notify.error('An error has occurred, please try again later');
    }

    showSuccessMessage(message) {
        notify.success(message);
    }

    cancelOrder() {
        jQuery('.cancel-order').click(function (e) {
            e.preventDefault();
            var orderCancelUrl = jQuery(this).attr('href');
            window.jQuery.LoadingOverlay('show');
            jQuery
                .ajax(orderCancelUrl, {
                    method: 'GET',
                    success: function () {
                        location.reload();
                    },
                })
                .fail(function () {
                    self.showErrorMessage();
                })
                .always(function () {
                    window.jQuery.LoadingOverlay('hide');
                });
        });
    }

    changeReferer() {
        var inputReferer = jQuery('input[name="_wp_http_referer"]');

        const urlParams = new URLSearchParams(window.location.search);
        const redirect = urlParams.get('redirect');

        inputReferer.val(redirect);
    }

    init() {
        if (this.account.length) {
            this.deletePaymentMethod();
            this.setDefaultPaymentMethod();
            this.pausePlan();
            this.cancelOrder();
            this.addPaymentMethod();
            this.downloadInvoice();
            this.removeBirthCertificate();
        }

        this.changeReferer();
    }
}
